export const FallbackIoTDBAccessFrequency = 60000;
